{
  "org": {
    "meridian": "Meridian Crest Capital",
    "augi": "AUGI"
  },
  "nav": {
    "build": "Build",
    "apps": "Apps"
  },
  "empty": {
    "liveTitle": "Waiting for work",
    "liveBody": "This screen fills on its own when someone at Meridian sends a weekly workflow from the HeavyRain app.",
    "demoTitle": "Weekly cycle ready",
    "demoBody": "Run the weekly cycle to load approved work and build the app."
  },
  "panel": {
    "eyebrow": "Background build",
    "receivedTitle": "Received {app}",
    "buildingTitle": "Building {app}",
    "requestedBy": "Requested by {name}, {role}",
    "progress": "Progress",
    "phases": {
      "received": "Request received",
      "reading": "Reading workflow",
      "building": "Building application",
      "checking": "Running final checks",
      "ready": "Preview ready"
    },
    "footer": "The preview opens on its own when the build is ready.",
    "failedTitle": "Build stopped",
    "failedBody": "The build stopped ({reason}); send the request again from the HeavyRain app.",
    "stoppedBody": "The build stopped early because it reached the time or token limit for this run.",
    "waitingInputBody": "The build cannot continue because it is waiting for input that this console cannot provide."
  },
  "feed": {
    "label": "Builder steps as they happen",
    "tokens": "Tokens: {n}",
    "files": "Files written: {n}",
    "handoffTitle": "Brief handed to hosted sandbox worker",
    "handoffDetail": "The relay packaged {name}'s workflow, proposed app, and design stylesheet into one brief. It started Google's hosted Antigravity agent on {model} in a 4 vCPU, 16 GB Linux sandbox. The console follows live thought summaries, tool calls, files written, tokens, page snapshots, and the progress file."
  },
  "card": {
    "open": "Open application"
  },
  "workers": {
    "Researcher": "Catalog matcher",
    "Connector": "Schema checker",
    "Builder": "App builder",
    "Notifier": "Release drafter",
    "Cairn": "Weekly coordinator",
    "Relay": "Report intake"
  },
  "reset": "Reset",
  "start": "Start",
  "buildMode": {
    "label": "Build mode",
    "flash": "Flash · Quick scaffold",
    "argon": "Argon · High-fidelity app",
    "startFlash": "Start with Flash",
    "startArgon": "Start with Argon"
  }
}
